import React from 'react';
import { usePaymentSettings } from './presenter';
import { SettingsPaymentView } from './view';
import { useToast } from '../../../components/ui/Toaster';
import { useConfirm } from '../../../components/ui/ConfirmDialog';
import { Route } from '../../../components/layout/ProtectedLayout';

export type Props = {
  navigate: (r: Route) => void;
};

const SettingsPaymentPage: React.FC<Props> = () => {
  const vm = usePaymentSettings();
  const toast = useToast();
  const confirm = useConfirm();

  return (
    <SettingsPaymentView
      loading={vm.loading}
      saving={vm.saving}
      error={vm.error}
      environment={vm.environment}
      setEnvironment={vm.setEnvironment}
      merchantId={vm.merchantId}
      setMerchantId={vm.setMerchantId}
      baseUrlApi={vm.baseUrlApi}
      setBaseUrlApi={vm.setBaseUrlApi}
      baseUrlApp={vm.baseUrlApp}
      setBaseUrlApp={vm.setBaseUrlApp}
      clientKeyMasked={vm.data?.clientKeyMasked}
      serverKeyMasked={vm.data?.serverKeyMasked}
      newClientKey={vm.newClientKey}
      setNewClientKey={vm.setNewClientKey}
      newServerKey={vm.newServerKey}
      setNewServerKey={vm.setNewServerKey}
      lowStockThreshold={vm.lowStockThreshold}
      setLowStockThreshold={vm.setLowStockThreshold}
      onSave={async () => {
        const ok = await confirm({ title: 'Save Settings', message: 'Update payment settings?', confirmText: 'Save' });
        if (!ok) return;
        await vm.save();
        toast.success('Settings saved');
      }}
      onReload={() => vm.reload()}
    />
  );
};

export default SettingsPaymentPage;
